/**
+ * JSON Schema for the req.body object of the merge endpoint.
+ *
+ * http://json-schema.org/
+ */
const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
  id: "mergeSchema",
  type: "object",
  properties: {
    username: {
      type: "string",
      pattern: emailPattern,
      required: true
    },
    password: {
      type: "string",
      required: true
    },
    socialProvider: {
      type: "string",
      required: true
    },
    socialUserToken: {
      type: "string",
      required: true
    }
  }
};
